import { render, staticRenderFns } from "./DocumentationStarted.vue?vue&type=template&id=010596c8"
import script from "./DocumentationStarted.vue?vue&type=script&lang=js"
export * from "./DocumentationStarted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports